import React from 'react';
import { useClinicalReports } from '../../clinical-reports/ClinicalReportsContext';
import ReportSectionHead from '../../head-doctor/reports/ReportSectionHead';
import { NursingCareReportSection } from '../../head-doctor/reports/nursingReportSections';

export default function MajorReportsInjectionsPage() {
  const { data, summary, loading, copy: COPY, hasActiveAdvancedFilters, clearAdvancedFilters } =
    useClinicalReports();

  return (
    <>
      <ReportSectionHead
        badge={COPY.SUB_INJECTIONS}
        title={COPY.PAGE_INJECTIONS_TITLE}
        description={COPY.PAGE_INJECTIONS_DESC}
      />

      <NursingCareReportSection
        data={data}
        summary={summary}
        loading={loading}
        copy={COPY}
        mode="injection"
        emptyHint={COPY.EMPTY_FILTERED_HINT}
        clearFiltersLabel={COPY.EMPTY_CLEAR_FILTERS}
        onClearFilters={hasActiveAdvancedFilters ? clearAdvancedFilters : null}
      />
    </>
  );
}
